import { IBaseEntity } from '@/types/api/app/common';

export interface IAppCategory extends IBaseEntity {
  title: string;
  description: string;
  status: CategoryStatus;
  productIds: number[];
  headerPhotoUrl?: string | null;
  thumbnailUrl: string | null;
  blurDataUrl?: string;
  slug: string;
}

export enum CategoryStatus {
  Disabled = 'disabled',
  Active = 'active',
}
